// Products.js
import React, { useState } from "react";
import "./Products.css";
import {
  FaCheckCircle,
  FaMicrochip,
  FaServer,
  FaCloud,
  FaRobot,
  FaLaptopCode,
  FaDatabase,
  FaRocket,
  FaHeadset,
  // FaArrowRight,
} from "react-icons/fa";
// import { Link } from "react-router-dom";
import { FaBuilding, FaMobileAlt, FaGlobe } from "react-icons/fa";


// Images
import Matchmaking from "../images/jusstmingle-logo.png";
import jantaPrabhav from "../images/jantaPrabhavLogo.jpg";
import jusstmingleAdmin from "../images/jusstmingle-logo.png";

const technologies = [
  {
    name: "AI & Machine Learning",
    icon: <FaRobot />,
    features: ["Predictive Analytics", "Chatbots & Automation", "Computer Vision"],
    bgColor: "#f8f9fa",
  },
  {
    name: "Cloud Infrastructure",
    icon: <FaCloud />,
    features: ["AWS & Azure Integration", "Scalable Deployment", "Data Backup Solutions"],
    bgColor: "#fffde7",
  },
  {
    name: "IoT & Embedded Systems",
    icon: <FaMicrochip />,
    features: ["Smart Devices", "Sensor Integration", "Edge Computing"],
    bgColor: "#f3e5f5",
  },

  // New cards
  {
    name: "Enterprise Applications",
    icon: <FaBuilding />,
    features: ["ERP/CRM to run ops", "One login (SSO)", "Reports & audit trails"],
    bgColor: "#e8f5e9",
  },
  {
    name: "Web Solutions",
    icon: <FaGlobe />,
    features: ["Fast React/Next.js", "SEO-friendly", "Easy content updates"],
    bgColor: "#e3f2fd",
  },
  {
    name: "Mobile App Development",
    icon: <FaMobileAlt />,
    features: ["iOS & Android apps", "Push & payments", "Publish to stores"],
    bgColor: "#fff3e0",
  },
  
];

const serviceHighlights = [
  {
    icon: <FaLaptopCode />,
    title: "Custom Software Development",
    description: "Scalable, maintainable, and secure code for web and mobile platforms.",
  },
  {
    icon: <FaServer />,
    title: "Server Management",
    description: "24/7 monitoring, automation, and optimized hosting environments.",
  },
  {
    icon: <FaDatabase />,
    title: "Big Data & Analytics",
    description: "Transform raw data into powerful business insights and decisions.",
  },
  {
    icon: <FaRocket />,
    title: "Tech Consultancy",
    description: "Strategy, architecture, and agile processes to accelerate your success.",
  },

   // ⬇️ New card
  {
    icon: <FaHeadset />,
    title: "24/7 Customer Support",
    description: "Always-on help via chat, email, and phone with SLA-based response.",
  },
];

const products = [
  {
    id: 1,
    name: "Jusst Mingle App",
    title: "Jusst Mingle — AI-Assisted Dating & Matchmaking",
    description:
      "A modern dating experience that helps people connect faster and safer with smart matching, privacy controls, and real-time chat.",
    image: Matchmaking, // reuse your existing image for now
    features: [
      "Smart profile matching (interests, preferences, behavior)",
      "Real-time chat with media sharing",
      "AI chatbot for conversation starters & safety tips",
      "User verification (selfie/ID) & report/ban flow",
      "Location-based discovery with privacy controls",
      "In-app notifications & activity feed"
    ],
    outcomes: ["↑ 31% match-to-chat conversion", "↓ 42% fake/abuse reports", "Scales to realtime traffic"],
    stack: ["React Native", "Node.js", "PostgreSQL", "AWS"],
  },

  /* 2) Jusst Mingle Admin Dashboard */
  {
    id: 2,
    name: "Jusst Mingle Admin",
    title: "Jusst Mingle — Admin Dashboard & Moderation Suite",
    description:
      "Centralized control for operations, trust & safety, and communications—built for visibility and fast actions.",
    image: jusstmingleAdmin, // placeholder; swap to your admin screenshot when ready
    features: [
      "Today’s active users & new registrations",
      "Gender split (male/female/other) & cohort views",
      "Suspended users & reported users queue",
      "Bulk notifications and targeted user messages",
      "Role-based access control & audit logs",
      "Config flags (feature toggles, limits, thresholds)"
    ],
    outcomes: ["Faster moderation SLAs", "Clear daily ops snapshot", "Scalable user comms"],
    stack: ["React (Web) / React Native", "PostgreSQL", "AWS"],
  },

  /* 3) Janta Prabhav — Dynamic News & Subscriptions */
  {
    id: 3,
    name: "Janta Prabhav",
    title: "Janta Prabhav — Dynamic News Portal with Subscriptions",
    description:
      "A dynamic news website with admin and user dashboards, daily updates, home-delivery paper subscriptions, and easy applications for contributors.",
    image: jantaPrabhav, // placeholder; swap to your site screenshot
    features: [
      "User dashboard: daily news feed & personalized updates",
      "Registration & simple form to start newspaper delivery",
      "Integrated payments for subscriptions",
      "Apply to work on the paper (contributor onboarding)",
      "Admin dashboard: content publishing & user management",
      "Notifications & email/SMS updates"
    ],
    outcomes: ["Smooth signup to doorstep delivery", "Fewer support calls via self-service", "Faster content publishing"],
    stack: ["React.js (Frontend)", "Node.js (Backend)", "Postgress"],
  }
];


const Products = () => {
  const [selected, setSelected] = useState(products[0]);

  return (
    <div className="product-page">
      <h2 className="product-title">Innovative Technologies We Offer</h2>
      <p className="product-subtitle">
        Empowering your business through cutting-edge development & cloud-first strategies.
      </p>

      {/* Technologies / plans */}
      <div className="plans-container">
        {technologies.map((tech, index) => (
          <div className="plan-card" style={{ backgroundColor: tech.bgColor }} key={index}>
            <div className="plan-icon">{tech.icon}</div>
            <h3>{tech.name}</h3>
            <ul className="feature-list">
              {tech.features.map((feature, idx) => (
                <li key={idx}>
                  <FaCheckCircle className="check-icon" /> {feature}
                </li>
              ))}
            </ul>
            {/* <Link to="/" className="subscribe-btn">
              Learn More <FaArrowRight style={{ marginLeft: 8 }} />
            </Link> */}
          </div>
        ))}
      </div>

      {/* Services */}
      <section className="insta-style-section">
        <h2 className="interactive-title">Our Software Services</h2>
        <p className="interactive-subtitle">
          Everything you need to build, scale, and launch your digital product.
        </p>

        <div className="interactive-container">
          {serviceHighlights.map((feature, index) => (
            <div className="interactive-card" key={index}>
              <div className="interactive-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Capabilities */}
      <section className="capabilities-section">
        <h2 className="capabilities-title">What Sets Us Apart</h2>
        <p className="capabilities-subtitle">
          Explore our key strengths in software development and enterprise IT.
        </p>

        <div className="capabilities-grid">
          <div className="capability-card">
            <h4>🌐 Scalable Architecture</h4>
            <p>Designed to grow as your business evolves — no rework required.</p>
          </div>
          <div className="capability-card">
            <h4>🔒 Security First</h4>
            <p>Encryption, compliance, and zero-trust policy for all systems.</p>
          </div>
          <div className="capability-card">
            <h4>🚀 Rapid Development</h4>
            <p>Agile and DevOps-driven delivery that accelerates go-to-market.</p>
          </div>
          <div className="capability-card">
            <h4>🧠 Full-Stack Innovation</h4>
            <p>From cloud backend to pixel-perfect frontend — we do it all.</p>
          </div>
        </div>
      </section>

      {/* Product Switcher */}
      <div className="product-section">
        <aside className="product-sidebar">
          <h2>Direct-to-Customer (D2C)</h2>
          {products.map((p) => (
            <button
              key={p.id}
              className={`product-button ${selected.id === p.id ? "active" : ""}`}
              onClick={() => setSelected(p)}
            >
              {p.name}
            </button>
          ))}
        </aside>

        <div className="product-details">
          <div className="product-image-top">
            <img
              src={selected.image}
              alt={selected.name}
              className="product-image-preview"
              loading="lazy"
            />
            <h3 className="product-image-name">{selected.name}</h3>
          </div>

          <div className="product-info">
            <h4 className="product-info-title">{selected.title}</h4>
            <p className="product-info-desc">{selected.description}</p>

            {/* Outcomes chips (add-only UI) */}
            {selected.outcomes?.length > 0 && (
              <>
                <h5 className="product-info-heading">Outcomes</h5>
                <div className="chip-row">
                  {selected.outcomes.map((o, i) => (
                    <span className="chip" key={i}>{o}</span>
                  ))}
                </div>
              </>
            )}

            <h5 className="product-info-heading">Key Features</h5>
            <ul className="product-features">
              {selected.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>

            {/* Stack chips (add-only UI) */}
            {selected.stack?.length > 0 && (
              <>
                <h5 className="product-info-heading">Tech Stack</h5>
                <div className="chip-row">
                  {selected.stack.map((t, i) => (
                    <span className="chip alt" key={i}>{t}</span>
                  ))}
                </div>
              </>
            )}

            <button className="demo-button">Request a Demo</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
